module.exports = __webpack_public_path__ + "img/IM.46d995fd.svg";